import { WinflowsFileManagmentAPI } from '../../../shared/api/url-helper';

// Function to convert the folder structure
function convertFolderStructure(input) {
  const result = [];
  const map = {};
  let parentCounter = 1;
  input.forEach(path => {
    const parts = path.split('/');
    let currentLevel = result;
    let currentId = '';
    let childCounter = 1;

    parts.forEach((part, i) => {
      const currentPath = parts.slice(0, i + 1).join('/');
      let existingItem = map[currentPath];

      if (!existingItem) {
        if (i === 0) {
          // Top-level item
          currentId = String(parentCounter);
          parentCounter += 1;
        } else {
          // Child item
          currentId = `${currentId}-${childCounter}`;
          childCounter += 1;
        }

        const newItem = {
          id: currentId,
          name: part,
          isFolder: true,
          items: []
        };

        map[currentPath] = newItem;
        currentLevel.push(newItem);
        existingItem = newItem;
      } else {
        // Reset childCounter when entering an existing folder
        childCounter = existingItem.items.length + 1;
        currentId = existingItem.id;
      }

      currentLevel = existingItem.items;
    });
  });
  return result;
}

// Function to fetch folder structure
export async function fetchFolderStructure() {
  const userMailId = sessionStorage.getItem('user_email');
  let getUserType = '';
  if (userMailId) {
    getUserType = userMailId.split('@')[1] === 'veolia.com' ? 'internal' : 'external';
  }

  const getParams = {
    email: userMailId,
    userType: getUserType,
    source_path: '',
    operation: 'list_folders'
  };

  try {
    const response = await WinflowsFileManagmentAPI(getParams);
    let result = '';
    if (response.data.folders.length === 0) {
      result = ['winflow 5.0'];
    } else {
      result = response.data.folders;
    }
    return convertFolderStructure(result);
  } catch (error) {
    // Using a custom logger or error reporting service would be better here
    // eslint-disable-next-line no-console
    console.error('Failed to fetch folder structure:', error);
    throw error; // Re-throw the error so it can be handled by the caller
  }
}